import { SalesforceField } from '../../../../../model/SalesforceField';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import '../../../../Pages/ArticleParts/TextBlocks/styles/List.module.scss';

const SalesforceRichTextArea = ({ fields, className }: SalesforceField) => {
  return (
    <div className={`mb-4 salesforce-rich-text ${className}`}>
      <RichText tag="div" field={fields.richTextArea} />
    </div>
  );
};

export default SalesforceRichTextArea;
